import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { FwcModalSlide, FwcPreloader } from '../../../../fwc-lib.js';
import { AppConstants } from '../../../common/constants/app-constants';
import { DataService } from '../../../common/services/data.service';
import { UserCacheService } from '../../../common/services/user-cache.service';
import { TokenService } from '../../services/token.service';

@Component({
    selector: 'sae-global-header',
    templateUrl: './global-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GlobalHeaderComponent implements OnDestroy {
  header: {
    brandLogo: string,
    universityLogo: string,
    universityLabel: string
  };
  token: string;
  participantId: number = null;
  displaySpinner = false;
  storyId: string = null;
  micrositeId: string = null;
  menuDisplay = true;
  modal: any;
  private ds: any;
  constructor(
    public userCacheService: UserCacheService,
    public router: Router,
    public dataService: DataService,
    public logoutService: TokenService
  ) {
    const fwcPreloader = new FwcPreloader();
    fwcPreloader.build();
    this.participantId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
    this.storyId = this.userCacheService.getUserData(AppConstants.STORY_ID);
    this.micrositeId = this.userCacheService.getUserData(AppConstants.MICROSITE_ID);
    this.header = this.userCacheService.getUserData(AppConstants.GLOBAL_HEADER);
    this.token = this.userCacheService.getUserData(AppConstants.TOKEN);
    this.ds = dataService.announcement.subscribe(announce => {
      if (announce != null) {
        if (announce.topic === AppConstants.STORY_ID) {
          this.storyId = announce.message;
          this.token = null;
          this.header = null;
          this.participantId = null;
          this.userCacheService.eraseUserData(AppConstants.PARTICIPATION_ID);
        }
        if (announce.topic === AppConstants.PARTICIPATION_ID) {
          this.participantId = announce.message;
          this.token = null;
          this.header = null;
          this.storyId = null;
          this.userCacheService.eraseUserData(AppConstants.STORY_ID);
          this.micrositeId = this.userCacheService.getUserData(AppConstants.MICROSITE_ID);
        }
        if (announce.topic === AppConstants.GLOBAL_HEADER) {
          this.header = announce.message;
        }
        if (announce.topic === AppConstants.TOKEN) {
          this.token = announce.message;
        }
        if (announce.topic === AppConstants.HIDE_MENU) {
          this.menuDisplay = !announce.message;
        }
      }
    });
    if (this.participantId) {
      this.storyId = null;
      this.userCacheService.eraseUserData(AppConstants.STORY_ID);
    }
  }

  navigateTo(path: string): void {
    this.router.navigate([path]);
  }

  ngOnDestroy(): void {
    if (this.ds) {
      this.ds.unsubscribe();
    }
  }
  openModalSlider(): void {
    const fwcModalSlide = new FwcModalSlide();
    fwcModalSlide.build();
    this.modal = document.getElementById('fwcMobileHeadSlider');
    if (this.modal.hasChildNodes()) {
      this.modal.removeChild(this.modal.firstChild);
    }
    const modalContent = document.getElementById('mobile-header-slider');
    if (this.modal && modalContent) {
      this.modal.appendChild(modalContent);
    }
    this.modal.setAttribute('open', '');
  }
  closeModalSlider(e): void {
    const holder = document.getElementById('template-holder-mobileHead');
    const modalContent = document.getElementById('mobile-header-slider');
    if(holder) {
      holder.appendChild(modalContent);
    }
  }
  logout(): void {
    // this.token = null;
    this.displaySpinner = true;
    
    // Save IDs to localStorage BEFORE clearing user data
    if (this.participantId) {
      localStorage.setItem('participantId', this.participantId.toString());
    }
    if (this.storyId) {
      localStorage.setItem('storyId', this.storyId);
    }
    if (this.micrositeId) {
      localStorage.setItem('micrositeId', this.micrositeId);
    }
    
    this.logoutService.logout().subscribe(data => {
      this.userCacheService.eraseAllUserData();
      this.dataService.userLoggedIn(false);
      this.displaySpinner = false;
      window.location.href = '/logout';
    }, err => {
      this.displaySpinner = false;
      this.userCacheService.eraseAllUserData();
      this.dataService.userLoggedIn(false);
      window.location.href = '/logout';
    });
  }
}
